<div class="index_wrap">
    <div class="user-data-page clearfix d-lg-flex">
      <div class="coutom_two coutom_two_new">
        <div class="container mt-50 mb-50">
            <div id="cards" class="row">
                <div class="col-md-2 hide_wrap"></div>
                <div class="col-lg-4 col-md-6">
                    <div class="card">
                        <div class="card-body"><img src="assets/images/assets/srinagar_smc.png">
                            <h4>Citizen Login</h4>
                            <div class="d-inline-flex">
                                <a routerLink="/home" class="note-btn-primary" contenteditable="false" style="cursor: pointer;"><span id="admin">Click Here To Login</span></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="card">
                        <div class="card-body"><img src="assets/images/assets/srinagar_smc.png">
                            <h4>Department Login</h4>
                            <div class="d-inline-flex">
                                <a href="/department" target="_blank" class="note-btn-primary" contenteditable="false" style="cursor: pointer;"><span id="admin">Click Here To Login</span></a>
                            </div>
                        </div>
                    </div>
                </div>

                
            </div>
        </div>
      </div>
    </div>
  </div>
  